import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49ec4817"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "diseasePopup",
  class: "popup-vue"
}
const _hoisted_2 = { class: "add-new" }
const _hoisted_3 = { class: "mb20" }
const _hoisted_4 = { class: "sub-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "code" }, "code", -1))
const _hoisted_6 = ["readonly"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "nameKr" }, "KR", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "" }, "EN", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "" }, "RU", -1))
const _hoisted_10 = { class: "btn-confirm-wrap" }

import { onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'DiseasePopup',
  props: {
  context: {
    type: String,
    required: false,
  },
  popupTitle: {
    type: String,
    required: true,
  },
  popupDesc: {
    type: String,
    required: false,
  },
  popupVersion: {
    type: String,
    required: true,
  },
  checkedDisease_all: {
    type: Object,
    required: false,
  },
},
  emits: ['onClick_cancel', 'onClick_close', 'onClick_disease_all'],
  setup(__props, { emit }) {

const props = __props;

const store = useStore();
const Set = store.state.moduleSet;


/**** data -------------------- */
var item = ref({
  code: ``,
  nameEn: ``,
  nameKr: ``,
  nameRu: ``,
});
var isValid = ref({
  code: false,
  nameEn: false,
  nameKr: false,
  nameRu: false,
});
var validMsg = ref({
  code: ``,
  nameEn: ``,
  nameKr: ``,
  nameRu: ``,
});
/**** methods ----------------- */
/**
 * 유효성 검사
 */
const checkValid_code = async () => {
  let reg_code = /(?=.*[0-9])(?=.*?[A-Z]).{4,4}$/;
  if (props.popupVersion === '01') {
    isValid.value.code = true;
    validMsg.value.code = '등록된 코드는 수정할 수 없습니다.';
    return;
  } else {
    if (item.value.code === ``) {
      isValid.value.code = false;
      validMsg.value.code = `코드를 입력해 주세요.`;
    } else {
      if (!reg_code.test(item.value.code)) {
        isValid.value.code = false;
        validMsg.value.code = '코드 4자리 (영어 대문자 + 숫자)를 입력해 주세요.';
      } else {
        isValid.value.code = true;
        validMsg.value.code = '코드를 바르게 입력했습니다.';
      }
    }
  }
};
const checkValid_nameKr = async () => {
  let reg_nameKr = /^[가-힣]{2,10}$/;
  if (item.value.nameKr === ``) {
    isValid.value.nameKr = false;
    validMsg.value.nameKr = `한국어를 입력해 주세요.`;
  } else {
    if (!reg_nameKr.test(item.value.nameKr)) {
      isValid.value.nameKr = false;
      validMsg.value.nameKr = '한국어 2~10자 (띄어쓰기 불가)을 입력해 주세요.';
    } else {
      isValid.value.nameKr = true;
      validMsg.value.nameKr = '한국어를 바르게 입력했습니다.';
    }
  }
};
const checkValid_nameEn = async () => {
  let reg_nameEn = /^[A-Z]{1}[a-z/ ]{3,23}$/;
  if (item.value.nameEn === ``) {
    isValid.value.nameEn = false;
    validMsg.value.nameEn = `영어를 입력해 주세요.`;
  } else {
    if (!reg_nameEn.test(item.value.nameEn)) {
      isValid.value.nameEn = false;
      validMsg.value.nameEn = '영어 4~24자 (첫 글자 대문자 + 이하 소문자)를 입력해 주세요.';
    } else {
      isValid.value.nameEn = true;
      validMsg.value.nameEn = '영어를 바르게 입력했습니다.';
    }
  }
};
const checkValid_nameRu = async () => {
  let reg_nameRu = /^[\u0410-\u044F\u0500-\u052F\u0400-\u04FF/ ]{4,24}$/;
  if (item.value.nameRu === ``) {
    isValid.value.nameRu = false;
    validMsg.value.nameRu = `러시아어를 입력해 주세요.`;
  } else {
    if (!reg_nameRu.test(item.value.nameRu)) {
      isValid.value.nameRu = false;
      validMsg.value.nameRu = '러시아어 4~24자를 입력해 주세요.';
    } else {
      isValid.value.nameRu = true;
      validMsg.value.nameRu = '러시아어를 바르게 입력했습니다.';
    }
  }
};
const checkVailid_all = async () => {
  await (() => {
    checkValid_code();
    checkValid_nameKr();
    checkValid_nameEn();
    checkValid_nameRu();
  })();
  if (isValid.value.code === true && isValid.value.nameEn === true && isValid.value.nameKr === true && isValid.value.nameRu === true) {
    return true;
  } else {
    return false;
  }
};
const addNew_disease_all = async () => {
  store.dispatch('moduleSet/addNew_disease_all', item.value, { root: true });
  emit('onClick_close');
  emit('onClick_disease_all', item.value.code, Set.diseases_all.length);
};
const modify_disease_all = async () => {
  store.dispatch('moduleSet/modify_disease_all', item.value, { root: true });
  emit('onClick_close');
};
const onClick_confirm = async () => {
  let flag = await checkVailid_all();
  if (flag) {
    addNew_disease_all();
  } else {
    return;
  }
};
const onClick_modify = async () => {
  let flag = await checkVailid_all();
  if (flag) {
    modify_disease_all();
  } else {
    return;
  }
};
/**** content -----------------
 *
 * 진료질환 팝업
 * /
 * /
/**** hook -------------------- */
onMounted(() => {
  if (props.popupVersion === '01') {
    if (props.checkedDisease_all !== undefined) {
      item.value.code = props.checkedDisease_all.code;
      item.value.nameEn = props.checkedDisease_all.nameEn;
      item.value.nameKr = props.checkedDisease_all.nameKr;
      item.value.nameRu = props.checkedDisease_all.nameRu;
    }
  }
});
watch(
  () => item.value.code,
  () => {
    item.value.code = item.value.code.replace(/\s/gi, '');
    checkValid_code();
  }
);
watch(
  () => item.value.nameEn,
  () => {
    item.value.nameEn = item.value.nameEn.replace(/^[\s\uFEFF\xA0]+/gi, '');
    checkValid_nameEn();
  }
);
watch(
  () => item.value.nameKr,
  () => {
    item.value.nameKr = item.value.nameKr.replace(/^[\s\uFEFF\xA0]+/gi, '');
    item.value.nameKr = item.value.nameKr.replace(/[\s\uFEFF\xA0]+$/gi, '');
    checkValid_nameKr();
  }
);
watch(
  () => item.value.nameRu,
  () => {
    item.value.nameRu = item.value.nameRu.replace(/^[\s\uFEFF\xA0]+/gi, '');
    // item.value.nameRu = item.value.nameRu.replace(/[\s\uFEFF\xA0]+$/gi, '');
    checkValid_nameRu();
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      _createElementVNode("fieldset", _hoisted_3, [
        _createElementVNode("legend", _hoisted_4, _toDisplayString(props.popupTitle), 1),
        _createElementVNode("div", null, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            name: "code",
            id: "code",
            placeholder: "코드 4자리 (영어 대문자 + 숫자)",
            required: "true",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(item).code) = $event)),
            readonly: __props.popupVersion === '01'
          }, null, 8, _hoisted_6), [
            [_vModelText, _unref(item).code]
          ]),
          _withDirectives(_createElementVNode("p", {
            class: _normalizeClass([_unref(isValid).code ? 'valid-msg-ok' : 'valid-msg'])
          }, _toDisplayString(_unref(validMsg).code), 3), [
            [_vShow, _unref(validMsg).code !== ``]
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            name: "nameKr",
            id: "nameKr",
            placeholder: "한국어 2~10자 (띄어쓰기 불가)",
            required: "true",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(item).nameKr) = $event))
          }, null, 512), [
            [_vModelText, _unref(item).nameKr]
          ]),
          _withDirectives(_createElementVNode("p", {
            class: _normalizeClass([_unref(isValid).nameKr ? 'valid-msg-ok' : 'valid-msg'])
          }, _toDisplayString(_unref(validMsg).nameKr), 3), [
            [_vShow, _unref(validMsg).nameKr !== ``]
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            name: "nameEn",
            id: "nameEn",
            placeholder: "영어 4~24자 (첫 글자 대문자 + 이하 소문자)",
            required: "true",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(item).nameEn) = $event))
          }, null, 512), [
            [_vModelText, _unref(item).nameEn]
          ]),
          _withDirectives(_createElementVNode("p", {
            class: _normalizeClass([_unref(isValid).nameEn ? 'valid-msg-ok' : 'valid-msg'])
          }, _toDisplayString(_unref(validMsg).nameEn), 3), [
            [_vShow, _unref(validMsg).nameEn !== ``]
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            name: "nameRu",
            id: "nameRu",
            placeholder: "러시아어 4~24자",
            required: "true",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(item).nameRu) = $event))
          }, null, 512), [
            [_vModelText, _unref(item).nameRu]
          ]),
          _withDirectives(_createElementVNode("p", {
            class: _normalizeClass([_unref(isValid).nameRu ? 'valid-msg-ok' : 'valid-msg'])
          }, _toDisplayString(_unref(validMsg).nameRu), 3), [
            [_vShow, _unref(validMsg).nameRu !== ``]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          class: "btn btn-type-1",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('onClick_cancel')))
        }, "취소"),
        (__props.popupVersion === '00')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-type-2",
              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (onClick_confirm()), ["prevent"]))
            }, "확인"))
          : _createCommentVNode("", true),
        (__props.popupVersion === '01')
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-type-2",
              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (onClick_modify()), ["prevent"]))
            }, "수정"))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})